import React, { createContext, useState, useContext, ReactNode } from 'react';
import { Action } from '../types/action';
import { UserRole } from '../components/actions/ActionsPanel';

interface CompletedActionsContextType {
  completedActions: Action[];
  addCompletedAction: (action: Action) => void;
  getCompletedActionsByRole: (role: UserRole) => Action[];
}

const CompletedActionsContext = createContext<CompletedActionsContextType | undefined>(undefined);

export const CompletedActionsProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [completedActions, setCompletedActions] = useState<Action[]>([]);

  const addCompletedAction = (action: Action) => {
    // Create a copy of the action with completedAt timestamp
    const completedAction = {
      ...action,
      completedAt: new Date().toISOString()
    };
    
    setCompletedActions(prev => [completedAction, ...prev]);
  };

  const getCompletedActionsByRole = (role: UserRole) => {
    return completedActions.filter(action => 
      action.applicableRoles.includes(role)
    );
  };

  return (
    <CompletedActionsContext.Provider 
      value={{ 
        completedActions, 
        addCompletedAction,
        getCompletedActionsByRole
      }}
    >
      {children}
    </CompletedActionsContext.Provider>
  );
};

export const useCompletedActions = (): CompletedActionsContextType => {
  const context = useContext(CompletedActionsContext);
  if (context === undefined) {
    throw new Error('useCompletedActions must be used within a CompletedActionsProvider');
  }
  return context;
}; 